import { createFileRoute } from '@tanstack/react-router';

import { DataBase } from '@mint-lib/icons';
import {
  buildGuards,
  hasPermission,
  isAgencyCompany,
  not,
  some,
} from '@mint-lib/routing-guards';

// TODO(STZF-23): fix guard duplication with sidebar in permissions refactoring
const sidebarGuard = buildGuards(
  not(isAgencyCompany),
  some(
    hasPermission('integrations:view'),
    hasPermission('dataManagementHubFeature:view'),
  ),
);

export const Route = createFileRoute('/_secured/external-data/')({
  staticData: {
    commandMeta: ({ t, check }) => {
      if (!check(sidebarGuard)) {
        return;
      }

      return {
        title: t('External Data'),
        keywords: [t('integrations'), t('import hub')],
        icon: DataBase,
      };
    },
  },
});
